import { Heart, ShoppingCart } from "lucide-react";
import { Link } from "react-router-dom";
import type { Product } from "../../types/domain";
import { formatVnd } from "../../data/products";

type ProductCardProps = {
  product: Product;
  compact?: boolean;
};

export function ProductCard({ product, compact = false }: ProductCardProps) {
  return (
    <article className={`product-card ${compact ? "product-card-compact" : ""}`}>
      <Link className="product-media" to={`/product/${product.slug}`} aria-label={product.name}>
        <div className="product-art" aria-hidden="true">
          <span>{product.category.slice(0, 2).toUpperCase()}</span>
        </div>
      </Link>
      <div className="product-copy">
        <div className="product-badges">
          {product.badges.slice(0, 2).map((badge) => (
            <span key={badge}>{badge}</span>
          ))}
        </div>
        <Link to={`/product/${product.slug}`} className="product-title">
          {product.name}
        </Link>
        <p>{product.fitment.slice(0, 2).join(" · ")}</p>
        <div className="product-price">
          <strong>{formatVnd(product.price)}</strong>
          {product.originalPrice ? <s>{formatVnd(product.originalPrice)}</s> : null}
        </div>
        <div className="product-meta">
          <span>{product.rating.toFixed(1)} sao</span>
          <span>Đã bán {product.sold}</span>
        </div>
      </div>
      <div className="product-actions">
        <button aria-label="Thêm vào yêu thích">
          <Heart aria-hidden="true" />
        </button>
        <button aria-label="Thêm vào giỏ">
          <ShoppingCart aria-hidden="true" />
        </button>
      </div>
    </article>
  );
}
